<style lang="scss">
.zoezi-google-map>div{
    min-height:100px;
    background:#eee;
    position:relative;
}
.zoezi-google-map>div>iframe{
    width:100%; height:100%;
}
.zoezi-google-map>div:after{
    content:'';
    display:block;
    position:absolute;
    left:0; top:0;
    width:100%; height:100%;
    background-color:currentColor;
    mix-blend-mode:screen;
    pointer-events:none;
}
.zoezi-google-map .zoezi-google-map-instruction{
    font-size: 14px;
    background:transparent;
    height:210px;
    left: 50%;
    margin-left: -150px;
    line-height: 24px;
    width:300px;
    position:absolute;
    top: 50%;
    margin-top: -105px;
    padding: 20px;
    white-space:pre-line;
    box-shadow:0 1px 3px rgba(0,0,0,.2), 0 3px 9px rgba(0,0,0,.1), 0 9px 27px rgba(0,0,0,.05);
    border-radius: 5px;
}
</style>

<template>
    <div class="zoezi-google-map">
        <div v-html="embed" :style="{ height: height, color: $root.colorToHex(color) }"></div>
        <div v-if="$root && $root.edit" class="zoezi-google-map-instruction">
            <template v-if="$store.state.language == 'sv'">
                <strong>Att skapa en inbäddningskod</strong><br>
                <ol>
                    <li>Öppna <a href="https://google.se/maps" target="_blank">Google Maps här &raquo;</a></li>
                    <li>Sök upp önskad plats</li>
                    <li>I vänsterpanelen, klicka på <em>Dela</em> <v-icon small>mdi-share-variant-outline</v-icon></li>
                    <li>Klicka på fliken <em>Bädda in en karta</em></li>
                    <li>Klicka på <em>Kopiera HTML</em></li>
                    <li>Klistra in koden i fältet <em>Inbäddningskod</em>.</li>
                </ol>
            </template>
            <template v-else-if="$store.state.language == 'en'">
                <strong>Creating an Embed Code</strong><br>
                <ol>
                    <li>Open <a href="https://google.se/maps" target="_blank">Google Maps here &raquo;</a></li>
                    <li>Search for the desired location</li>
                    <li>In the left panel, click on <em>Share</em> <v-icon small>mdi-share-variant-outline</v-icon></li>
                    <li>Click on the <em>Embed a map</em> tab</li>
                    <li>Click on <em>Copy HTML</em></li>
                    <li>Paste the code into the <em>Embed Code</em> field.</li>
                </ol>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-google-map',

    zoezi: {
        title: 'Google Map',
        icon: 'mdi-google-maps'
    },

    props: {
        embed: {
            title: 'Embed code',
            type: String,
            default: ''
        },
        height: {
            title: 'Height',
            type: String,
            fulltype: 'csssize'
        },
        color: {
            title: 'Overlay color',
            type: String,
            fulltype: 'color'
        },
    },
    data: () => ({
    }),
    methods: {

    }
}
</script>
